import { useContext } from 'react';

import { AppContext } from './AppContext';
import type { AppDefinition } from './contracts';

/** Current dashboard definition (brand, auth, ...). Throws outside `AppProvider`. */
export function useApp(): AppDefinition {
  const app = useContext(AppContext);
  if (!app) {
    throw new Error('useApp must be used inside <AppProvider>');
  }
  return app;
}
